import {
    StreamsByStreamKeyState,
    StreamState,
} from 'streamsState/store/streamedData/StreamedDataState';

export type LiquidityStreamState = StreamState<LiquiditySummaryDataState>;
export type LiquidityStreamsState =
    StreamsByStreamKeyState<LiquiditySummaryDataState>;

export interface LiquiditySummaryDataState {
    previousClosePrice?: number;
    averageDailyVolume?: number;
    oldOpenVol?: number;
    oldCloseVol?: number;
    histOpenVol?: number;
    histCloseVol?: number;
    /*
     * Intraday volume (since start of trading)
     */
    volume?: number;
    oldPredictedRemainingVolume?: number;
    rtaPredRemVol?: number;
    rtaPredTotVol?: number;
    volumeScale?: number;
    predCloseVol?: number;
    actualVsHistPct?: number;
    /*
     * Predicted traded volume (from start of trading to current time)
     */
    predictedTradedVolume?: number;

    oldPredictedClosingAuctionVolume?: number;
    /*
     * Predicted close auction volume
     */
    predictedClosingAuctionVolume?: number;
}

export const initialLiquiditySummaryDataState: LiquiditySummaryDataState = {};

export const isInitialLiquiditySummaryData = (
    data?: LiquiditySummaryDataState
) =>
    data &&
    JSON.stringify(data) === JSON.stringify(initialLiquiditySummaryDataState);

export const initialLiquiditySummaryStreamState: LiquidityStreamState = {
    data: initialLiquiditySummaryDataState,
    messages: [],
};
